import { IKeyValue } from "motw_core/Entity/IKeyValue";
import { IKeyValueLog } from "motw_core/Entity/IKeyValueLog";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import MotwLogicServer from "source/app/services/External/LogicServer/MotwLogicServer";

export function TodaysValueWithHistory({
    todaysValue,
    keyValue,
    sharedFunction,
}: {
    todaysValue: number;
    keyValue: IKeyValue;
    sharedFunction: ESharedFunction;
}) {
    const [prevEntries, setPrevEntries] = React.useState<IKeyValueLog[]>([]);

    React.useEffect(() => {
        MotwLogicServer.PreviousKeyValueEntries(sharedFunction).then(
            (keyValues) => setPrevEntries(keyValues)
        );
    }, [keyValue]);

    const alertMessage = prevEntries
        .map((kvl) => `${kvl.lastmodifiedtime} - ${kvl.value}`)
        .join("\r\n");

    return (
        <span
            onClick={() => alert(alertMessage)}
            data-tip="click for historical values"
        >
            {todaysValue}
        </span>
    );
}
